module.exports = __webpack_public_path__ + "img/882e194154f84ef5a5e4ffa37fde36ea.017ebdba.jpg";